<template>
  <el-dialog
    title="从课件库中选择课件"
    width="70%"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label-width="0">
        <el-select
          v-model="form.choose1"
          placeholder="请选择"
          style="width: 30%"
        >
          <el-option
            v-for="(item, index) in options1"
            :key="item"
            :label="item"
            :value="index"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="form.search"
          placeholder="请输入内容"
          style="
            width: 55%;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
          "
        ></el-input>
        <el-button type="primary" style="margin-top: 10px" @click="handleQuery"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item label-width="0">
        <template>
          <el-table
            ref="multipleTable"
            :data="form.tableData"
            row-key="id"
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            ></el-table-column>
            <el-table-column prop="id" label="id" v-if="false">
            </el-table-column>
            <el-table-column prop="title" label="名称"> </el-table-column>
            <el-table-column prop="typeName" label="课件类别">
            </el-table-column>
            <el-table-column prop="knowledgeName" label="知识点名称">
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template #default="scope">
                <span v-if="scope.row.type == '1'">视频</span>
                <span v-if="scope.row.type == '2'">音频</span>
                <span v-if="scope.row.type == '3'">文本</span>
                <span v-if="scope.row.type == '4'">文档</span>
                <span v-if="scope.row.type == '5'">音视频链接</span>
              </template>
            </el-table-column>

            <el-table-column prop="uname" label="上传人"> </el-table-column>
            <el-table-column
              prop="ctime"
              label="上传时间"
              :formatter="formatDate2"
            >
            </el-table-column>
          </el-table>
        </template>
      </el-form-item>
    </el-form>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button type="" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: [],
  inject: ['reload'],
  name: 'CourseChooseCourse',
  data() {
    return {
      visible: false,
      form: {
        time: 'new Date(2016, 9, 10, 18, 40)',
        choose1: '',
        choose2: '',
        search: '',
        tableData: [],
      },
      options1: ['课件名称', '知识点名称'],
      courseName: '',
      knowsId: '',
      structureId: '',
      courseWareId: '',
      // 分页
      pageObj: {
        page: 1,
        pageSize: 10,
      },
      // 总数
      total: 0,
      videoType: '',
      content: '',
      newArr: [],
      institutionId: '',
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    getList() {
      const { page, pageSize } = this.pageObj
      api
        .getList2({
          page,
          pageSize,
          courseWareId: this.courseWareId,
          videoType: this.videoType,
          content: this.content,
          status: '1',
          wareStatus: '1',
          uid: this.getUId,
          institutionId: this.institutionId,
        })
        .then(({ data }) => {
          data = data.data
          this.form.tableData = data.list
          this.total = data.total
        })
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      if (this.form.choose1 == '0') {
        this.videoType = this.form.choose1 + 1
      } else {
        this.videoType = 5
      }

      this.content = this.form.search
      this.getList()
    },

    // 时间戳转日期
    formatDate2(row, column, cellValue, index) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },

    // 初始化
    init(
      courseWareId,
      name,
      knowsId,
      structureId,
      sendChooseId,
      institutionId
    ) {
      //课件库id  课时名称  知识点id  课程架构id  sendChooseId从课件库中选中的id
      this.form.choose1 = ''
      this.form.search = ''
      this.visible = true
      this.courseName = name
      this.knowsId = knowsId
      this.structureId = structureId
      this.courseWareId = courseWareId
      this.institutionId = institutionId
      const { page, pageSize } = this.pageObj
      api
        .getList2({
          page,
          pageSize,
          courseWareId: this.courseWareId,
          status: '1',
          wareStatus: '1',
          uid: this.getUId,
          institutionId,
        })
        .then(({ data }) => {
          data = data.data
          this.form.tableData = data.list
          this.total = data.total
        })

      let that = this
      setTimeout(function () {
        if (sendChooseId) {
          for (let i = 0; i < that.form.tableData.length; i++) {
            if (that.form.tableData[i].id == sendChooseId) {
              that.$refs.multipleTable.toggleRowSelection(
                that.form.tableData[i],
                true
              )
            } else {
            }
          }
        }
      }, 500)
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.$refs.multipleTable.clearSelection() //每次关闭页面清空全部勾选
      // this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一个课件' })
      } else {
        let formdata = new FormData()
        formdata.append('zyVideoSectionId', this.structureId)
        formdata.append('title', this.courseName)
        formdata.append('knowledgeId', this.knowsId)
        formdata.append('id', selectedList[0].id)
        api.updateVideoData(formdata).then(({ data }) => {
          if (data.code == 100000) {
            this.$message({ type: 'success', message: data.msg })
            this.visible = false
            this.reload()
          }
        })
      }
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  max-height: 80%;
  overflow-y: auto;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
